import * as React from 'react';
import { styled } from 'styled-components';
import THEME from '../theme.js';
import { Briefcase } from './Icons/index.js';
const CreditorOrTenant = (props) => {
    return (React.createElement(EntityStyled, { active: props.active, onClick: props.onClick, selected: props.selected, "data-tooltip-id": "tooltip-default", "data-tooltip-content": props.tooltip },
        React.createElement(Briefcase, null),
        React.createElement("h3", null,
            props.name,
            " ",
            props.badge),
        React.createElement("p", null, props.description)));
};
export default CreditorOrTenant;
const EntityStyled = styled.div `
  padding: ${THEME.GRID_SPACING / 2}px;
  font-size: 0.8em;
  position: relative;
  user-select: none;
  cursor: pointer;
  position: relative;
  border-bottom: 1px solid lightgrey;
  background-color: ${(props) => (props.selected ? '#d4d4d4' : 'inherit')};

  &:first-child {
    border-top: 1px solid lightgrey;
  }

  &:hover {
    &::before {
      content: '';
      position: absolute;
      height: 7px;
      width: 7px;
      background-color: lightgrey;
      border-radius: 100%;
      top: 25px;
      left: 4px;
    }
  }

  ${(props) => props.active
    ? `
    background-color: ${THEME.SELECTED_BLUE};
    color: ${THEME.COLOR_SECONDARY};
    margin-top: -4px;
    padding-top: 14px;
    border-radius: 5px;
    border-bottom: none;
    `
    : ''}

  svg {
    position: absolute;
    top: 20px;
    left: 16px;
    height: 15px;
    width: 15px;
  }

  & > p,
  & > h3 {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    padding-left: 35px;
    margin: 0 0em;
  }
`;
//# sourceMappingURL=CreditorOrTenant.js.map